import {
  TableFilterQueryParamContextState,
  TableFilterQueryParamMap,
} from 'modules/experiments/types';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';

export const initialTableFilterQueryParamContextState: TableFilterQueryParamContextState = {
  /** Experiment Filters */
  experimentModifiedBy: [],
  setExperimentModifiedBy: noop,
  experimentTestSubject: [],
  setExperimentTestSubject: noop,
  experimentSystemConversionWinningCriteria: [],
  setExperimentSystemConversionWinningCriteria: noop,
  experimentCustomConversionWinningCriteria: [],
  setExperimentCustomConversionWinningCriteria: noop,
  experimentWinnerSelected: '',
  setExperimentWinnerSelected: noop,
  experimentSplitVariationsRandomly: '',
  setExperimentSplitVariationsRandomly: noop,

  /** Campaign Filters */
  campaignLabels: [],
  setCampaignLabels: noop,
  campaignMedium: [],
  setCampaignMedium: noop,
  campaignTypes: [],
  setCampaignTypes: noop,

  /** Update Query Params */
  queryParamMap: <TableFilterQueryParamMap>{},
  updateQueryParam: noop,
  clearQueryParam: noop,
};

export const TableFilterQueryParamContext = createContext(initialTableFilterQueryParamContextState);

export const useTableFilterQueryParamContext = () => useContext(TableFilterQueryParamContext);
